import { render, staticRenderFns } from "./AudioCategoryAddModal.vue?vue&type=template&id=08f3fa27"
import script from "./AudioCategoryAddModal.vue?vue&type=script&lang=js"
export * from "./AudioCategoryAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports